var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7520_17341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.895 33.9319C30.5156 33.9319 30.9294 33.5182 30.9294 32.8974L30.9294 16.9664C30.9294 16.3457 30.5156 15.9319 29.895 15.9319C29.2743 15.9319 28.8605 16.3457 28.8605 16.9664L28.8605 32.8974C28.8605 33.5182 29.2743 33.9319 29.895 33.9319Z",
    fill: "#BE323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5517 60 60 46.5517 60 30C60 13.4482 46.5517 3.8147e-06 30 3.8147e-06C13.4482 3.8147e-06 3.8147e-06 13.4482 3.8147e-06 30C3.8147e-06 46.5517 13.4482 60 30 60ZM30 2.06897C45.4138 2.06897 57.931 14.5862 57.931 30C57.931 45.4138 45.4138 57.931 30 57.931C14.5862 57.931 2.06897 45.4138 2.06897 30C2.06897 14.5862 14.5862 2.06897 30 2.06897Z",
    fill: "#BE323C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8978 43.9645C31.6564 43.9645 33.1047 42.5163 33.1047 40.7576C33.1047 38.999 31.6564 37.5507 29.8978 37.5507C28.1392 37.5507 26.6909 38.999 26.6909 40.7576C26.6909 42.5163 28.0357 43.9645 29.8978 43.9645ZM29.8978 39.5162C30.5185 39.5162 31.0358 40.0335 31.0358 40.6542C31.0358 41.2748 30.5185 41.7921 29.8978 41.7921C29.2771 41.7921 28.7598 41.2748 28.7598 40.6542C28.7598 40.0335 29.2771 39.5162 29.8978 39.5162Z",
    fill: "#BE323C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7520_17341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 -1 60 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.cd756a69a2af7cee40c0746a597e400d.svg";
export { ForwardRef as ReactComponent };